import React, { useEffect } from "react";
import { observer } from "mobx-react";
import Toast from "ui/Toast/Toast";
import CartFilledOrange from "assets/icons/14x14/cart-filled-orange.svg";
import { useStore } from "store";
import { useBreakpoint } from "helpers/hooks";
import { withTrailSlash } from "helpers/url";
import { ROUTE_CART } from "constants/routes";
import styles from "./ProductToast.module.scss";

type ProductToastProps = {
  item: Entity.Cart.Item;
  onClose?: () => void;
};

const ProductToast: React.FC<ProductToastProps> = ({
  item,
  ...rest
}: ProductToastProps) => {
  const { onClose } = rest;
  const { cart } = useStore();
  const productInCart = cart.get(item.product.id, {
    priceTypeID: item.priceTypeID,
  });
  const breakpoint = useBreakpoint();

  useEffect(() => {
    if (!productInCart) {
      onClose && onClose();
    }
  }, [onClose, productInCart]);

  /* No need toast when breakpoint undefined (load or SSR) */
  if (!productInCart || !breakpoint) return null;

  return (
    <a href={withTrailSlash(ROUTE_CART)} className={styles.productToastLink}>
      <Toast {...rest}>
        <div className={styles.productToast}>
          {productInCart?.product?.name}
          &nbsp;добавлен в&nbsp;
          <span>
            <CartFilledOrange />
            Корзину
          </span>
        </div>
      </Toast>
    </a>
  );
};

export default observer(ProductToast);
